import * as React from "react";

export const EndocrineThyroidKeyContent = () => (
  <>
<g id="Key">
      <rect width={1024} height={278} fill="white" />
<g id="Container_2">
        <g id="key-item - Gene">
          <rect x={40.5} y={66.5} width={386.748} height={183} stroke="#818181" />
          <text
            id="gene-label"
            fill="#1A1A1A"
            style={{ whiteSpace: "pre" }}
            xmlSpace="preserve"
            fontFamily="Gilroy W05 Bold"
            fontSize={12}
            letterSpacing="2.8px"
          >
            <tspan x={52.4383} y={86.4}>
              GENETICS
            </tspan>
          </text>
          <g id="Container_3">
            <g id="Container_4">
              <g id="Container_5">
                <g id="Component 2">
                  <g id="gene-lozenge">
                    <path
                      d="M56 96.3896H72C73.9941 96.3896 75.6104 98.0059 75.6104 100V116C75.6104 117.994 73.9941 119.61 72 119.61H56C54.0059 119.61 52.3896 117.994 52.3896 116V100C52.3896 98.0059 54.0059 96.3896 56 96.3896Z"
                      fill="#E5E5E5"
                    />
                    <path
                      d="M56 96.3896H72C73.9941 96.3896 75.6104 98.0059 75.6104 100V116C75.6104 117.994 73.9941 119.61 72 119.61H56C54.0059 119.61 52.3896 117.994 52.3896 116V100C52.3896 98.0059 54.0059 96.3896 56 96.3896Z"
                      stroke="#1A1A1A"
                      strokeWidth="0.778643"
                    />
                  </g>
                </g>
                <text
                  id="Description"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
            fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.0723} y={112.767}>
                    Not included in panel
                  </tspan>
                </text>
              </g>
              <g id="Container_6">
                <g id="Component 2_2">
                  <g id="gene-lozenge_2">
                    <path
                      d="M52 128C52 125.791 53.7909 124 56 124H72C74.2091 124 76 125.791 76 128V144C76 146.209 74.2091 148 72 148H56C53.7909 148 52 146.209 52 144V128Z"
                      fill="#CCBAFF"
                    />
                  </g>
                </g>
                <text
                  id="Description_2"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
            fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.2559} y={140.767}>
                    No read
                  </tspan>
                </text>
              </g>
              <g id="Container_7">
                <g id="Component 2_3">
                  <g id="snp-indicator">
                    <path
                      id="Polygon 3"
                      d="M63.3387 158.372C63.6326 157.876 64.3674 157.876 64.6613 158.372L70.8966 168.885C71.1905 169.381 70.8231 170 70.2352 170H57.7648C57.1769 170 56.8095 169.381 57.1034 168.885L63.3387 158.372Z"
                      fill="#1A1A1A"
                    />
                  </g>
                </g>
                <text
                  id="Description_3"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
            fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.1738} y={168.767}>
                    Increased activity
                  </tspan>
                </text>
              </g>
              <g id="Container_8">
                <g id="Component 2_4">
                  <g id="snp-indicator_2">
                    <path
                      id="Polygon 3_2"
                      d="M64.6613 197.628C64.3674 198.124 63.6326 198.124 63.3387 197.628L57.1034 187.115C56.8095 186.619 57.1769 186 57.7648 186L70.2352 186C70.8231 186 71.1905 186.619 70.8966 187.115L64.6613 197.628Z"
                      fill="#1A1A1A"
                    />
                  </g>
                </g>
                <text
                  id="Description_4"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
            fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={84.2285} y={196.767}>
                    Decreased activity
                  </tspan>
                </text>
              </g>
            </g>
            <g id="Container_9">
              <g id="Container_10">
                <g id="Component 2_5">
                  <g id="gene-lozenge_3">
                    <path
                      d="M237 100C237 97.7909 238.791 96 241 96H257C259.209 96 261 97.7909 261 100V116C261 118.209 259.209 120 257 120H241C238.791 120 237 118.209 237 116V100Z"
                      fill="#00BF86"
                    />
                  </g>
                </g>
                <text
                  id="Risk description"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
            fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={269.288} y={112.767}>
                    0 risk alleles
                  </tspan>
                </text>
              </g>
              <g id="Container_11">
                <g id="Component 2_6">
                  <g id="gene-lozenge_4">
                    <path
                      d="M237 128C237 125.791 238.791 124 241 124H257C259.209 124 261 125.791 261 128V144C261 146.209 259.209 148 257 148H241C238.791 148 237 146.209 237 144V128Z"
                      fill="#FF905F"
                    />
                  </g>
                </g>
                <text
                  id="Risk description_2"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
            fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={269.271} y={140.767}>
                    1 risk allele
                  </tspan>
                </text>
              </g>
              <g id="Container_12">
                <g id="Component 2_7">
                  <g id="gene-lozenge_5">
                    <path
                      d="M237 156C237 153.791 238.791 152 241 152H257C259.209 152 261 153.791 261 156V172C261 174.209 259.209 176 257 176H241C238.791 176 237 174.209 237 172V156Z"
                      fill="#FF5D6D"
                    />
                  </g>
                </g>
                <text
                  id="Risk description_3"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
            fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={269.006} y={168.767}>
                    2 risk alleles
                  </tspan>
                </text>
              </g>
            </g>
          </g>
          <g id="key-item - Not included">
            <g id="Icon">
              <path
                id="*"
                d="M63.7483 224.79V227.209L59.8178 227.08L62.0638 230.319L59.861 231.615L57.8741 228.116L55.8873 231.615L53.6845 230.319L55.9305 227.08L52 227.209L52 224.79L55.9305 224.92L53.6845 221.681L55.8873 220.385L57.8741 223.883L59.861 220.385L62.0638 221.681L59.8178 224.92L63.7483 224.79Z"
                fill="black"
              />
            </g>
            <text
              id="Explanation"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
            fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={73.748} y={230.086}>
                Limited / insufficient evidence for interpretation in this context
              </tspan>
            </text>
          </g>
        </g>
        <g id="Container_13">
          <g id="key-item - vitamin">
            <g id="Vitamin-Mineral">
              <g id="diamond">
                <path
                  id="Vector"
                  d="M481.126 66.9375L505.126 90.9375L481.126 114.938L457.126 90.9375L481.126 66.9375Z"
                  stroke="#1A1A1A"
                />
              </g>
            </g>
            <text
              id="Vitamin description"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
            fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={516.748} y={83.767}>
                Vitamin/
              </tspan>
              <tspan x={516.748} y={107.767}>
                Mineral
              </tspan>
            </text>
          </g>
          <g id="key-item - hormones">
            <g id="Hormones">
              <g id="diamond_2">
                <path
                  id="Vector_2"
                  d="M621.119 107.124C621.531 107.014 621.965 107.014 622.377 107.124L638.896 111.55C640.703 112.034 642.356 110.381 641.872 108.574L637.446 92.0553C637.335 91.6433 637.335 91.2095 637.446 90.7975L641.872 74.2788C642.356 72.4718 640.703 70.8184 638.896 71.3025L622.377 75.7286C621.965 75.839 621.531 75.839 621.119 75.7286L604.6 71.3025C602.793 70.8184 601.14 72.4718 601.624 74.2788L606.05 90.7975C606.161 91.2095 606.161 91.6433 606.05 92.0553L601.624 108.574C601.14 110.381 602.793 112.034 604.6 111.55L621.119 107.124Z"
                  stroke="#1A1A1A"
                  strokeMiterlimit="10"
                />
              </g>
            </g>
            <text
              id="Hormones_2"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
            fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={652.764} y={95.767}>
                Hormones
              </tspan>
            </text>
          </g>
          <g id="key-item - receptor protein">
            <path
              id="receptor-protein"
              d="M764.299 113.483L769.957 91.2796C770.095 90.738 770.095 90.1704 769.957 89.6288L764.577 68.5175C764.2 67.0365 762.866 66 761.338 66L750.287 66.0001C748.106 66.0001 746.509 68.0549 747.048 70.1683L752.027 89.7087C752.165 90.2503 752.165 90.8179 752.027 91.3595L746.81 111.832C746.272 113.945 747.869 116 750.05 116L761.06 116C762.588 116 763.922 114.964 764.299 113.483Z"
              stroke="#1A1A1A"
            />
            <text
              id="Receptor Protein"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
            fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={780.167} y={83.767}>
                Receptor
              </tspan>
              <tspan x={780.167} y={107.767}>
                Protein
              </tspan>
            </text>
          </g>
          <g id="key-item - co factor">
            <g id="Cofactor">
              <g id="diamond_3">
                <g id="Vector_3">
                  <mask id="path-28-inside-1_18293_224297" fill="white">
                    <path d="M888.167 70L909.167 80.1818V101.818L888.167 112L867.167 101.818V80.1818L888.167 70Z" />
                  </mask>
                  <path
                    d="M888.167 70L909.167 80.1818V101.818L888.167 112L867.167 101.818V80.1818L888.167 70Z"
                    stroke="#1A1A1A"
                    strokeWidth="2"
                    mask="url(#path-28-inside-1_18293_224297)"
                  />
                </g>
              </g>
            </g>
            <text
              id="Cofactor_2"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
            fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={919.168} y={95.767}>
                Cofactor
              </tspan>
            </text>
          </g>
          <g id="key-item - Inhibitor">
            <g id="lines">
              <g id="Frame 481">
                <path id="Vector_4" d="M456.448 164V148" stroke="#E44C4B" strokeWidth="1.4" />
                <path id="Vector_5" d="M457.148 156H509.748" stroke="#E44C4B" strokeWidth="1.4" />
              </g>
            </g>
            <text
              id="Inhibitor"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
            fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={520.183} y={160.767}>
                Inhibitor
              </tspan>
            </text>
          </g>
          <g id="key-item - affect">
            <g id="lines_2">
              <path
                id="Vector_6"
                d="M601.448 155.3C601.062 155.3 600.748 155.613 600.748 156C600.748 156.387 601.062 156.7 601.448 156.7V156V155.3ZM655.748 156L648.748 151.959V160.041L655.748 156ZM603.388 156.7C603.774 156.7 604.088 156.387 604.088 156C604.088 155.613 603.774 155.3 603.388 155.3V156V156.7ZM607.266 155.3C606.88 155.3 606.566 155.613 606.566 156C606.566 156.387 606.88 156.7 607.266 156.7V156V155.3ZM611.145 156.7C611.531 156.7 611.845 156.387 611.845 156C611.845 155.613 611.531 155.3 611.145 155.3V156V156.7ZM615.023 155.3C614.637 155.3 614.323 155.613 614.323 156C614.323 156.387 614.637 156.7 615.023 156.7V156V155.3ZM618.902 156.7C619.288 156.7 619.602 156.387 619.602 156C619.602 155.613 619.288 155.3 618.902 155.3V156V156.7ZM622.78 155.3C622.394 155.3 622.08 155.613 622.08 156C622.08 156.387 622.394 156.7 622.78 156.7V156V155.3ZM626.659 156.7C627.046 156.7 627.359 156.387 627.359 156C627.359 155.613 627.046 155.3 626.659 155.3V156V156.7ZM630.538 155.3C630.151 155.3 629.838 155.613 629.838 156C629.838 156.387 630.151 156.7 630.538 156.7V156V155.3ZM634.416 156.7C634.803 156.7 635.116 156.387 635.116 156C635.116 155.613 634.803 155.3 634.416 155.3V156V156.7ZM638.295 155.3C637.908 155.3 637.595 155.613 637.595 156C637.595 156.387 637.908 156.7 638.295 156.7V156V155.3ZM642.173 156.7C642.56 156.7 642.873 156.387 642.873 156C642.873 155.613 642.56 155.3 642.173 155.3V156V156.7ZM646.052 155.3C645.665 155.3 645.352 155.613 645.352 156C645.352 156.387 645.665 156.7 646.052 156.7V156V155.3ZM649.93 156.7C650.317 156.7 650.63 156.387 650.63 156C650.63 155.613 650.317 155.3 649.93 155.3V156V156.7ZM653.809 155.3C653.422 155.3 653.109 155.613 653.109 156C653.109 156.387 653.422 156.7 653.809 156.7V156V155.3ZM601.448 156V156.7H603.388V156V155.3H601.448V156ZM607.266 156V156.7H611.145V156V155.3H607.266V156ZM615.023 156V156.7H618.902V156V155.3H615.023V156ZM622.78 156V156.7H626.659V156V155.3H622.78V156ZM630.538 156V156.7H634.416V156V155.3H630.538V156ZM638.295 156V156.7H642.173V156V155.3H638.295V156ZM646.052 156V156.7L649.93 156.7V156V155.3L646.052 155.3V156Z"
                fill="#818181"
              />
            </g>
            <text
              id="Affect"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
            fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={665.748} y={148.767}>
                Negative
              </tspan>
              <tspan x={665.748} y={172.767}>
                feedback
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </g>
  </>
);

const SvgEndocrineThyroidKey = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={278}
    viewBox="0 0 1024 278"
    fill="none"
    {...props}
  >
    <EndocrineThyroidKeyContent />
  </svg>
);

export default SvgEndocrineThyroidKey;
